import { authHeader, config } from '../_helpers';

export const userService = {
    loginTemp,
    login,
    logout,
    register,
    handleMailchimp,
    leadHandle,
    getAll,
    getById,
    postData,
    update,
    deleteById,
    registerUser,
    Unsubscribe
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/users', requestOptions).then(handleResponse, handleError);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/users/' + id, requestOptions).then(handleResponse, handleError);
}

function postData(actioncontrol, params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params)
    };

    return fetch(config.apiUrl + '/' + actioncontrol, requestOptions).then(handleResponse, handleError);
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(config.apiUrl + '/users/register', requestOptions).then(handleResponse, handleError);
}

function handleMailchimp(MailchimpParam) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(MailchimpParam)
    };

    return fetch(config.apiUrl + '/User/SendToMailchimp', requestOptions).then(handleResponse, handleError);
}

function leadHandle(lead) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lead)
    };

    return fetch(config.apiUrl + '/User/CreateLeadToSF', requestOptions).then(handleResponse, handleError);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(config.apiUrl + '/users/' + user.id, requestOptions).then(handleResponse, handleError);
}

function deleteById(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/users/' + id, requestOptions).then(handleResponse, handleError);
}

function registerUser(regParameter) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(regParameter)
    };
    return fetch(config.apiUrl + '/User/RegisterUser', requestOptions)
    //return fetch(config.apiUrl + '/User/RegisterUser?code=' + code, requestOptions)
        .then(handleResponse, handleError)
        .then(user => {
            // user successful register then getting userID in the response            
            return user;
        });
}

function loginTemp(actioncontrol) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/' + actioncontrol, requestOptions).then(handleResponse, handleError);
}

function login(actioncontrol) {
    localStorage.removeItem('user');
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(config.apiUrl + actioncontrol, requestOptions)
        .then(handleResponse, handleError)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user != "") {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));

            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.clear();
    //localStorage.removeItem('user');
}

function Unsubscribe(email) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(config.apiUrl + '/product/UnsubscribeEtocAlerts/' + email, requestOptions).then(handleResponse, handleError);
}

function handleResponse(response) {
    return new Promise((resolve, reject) => {       
        if (response.ok) {
            // return json if it was returned in the response
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            } else {
                resolve();
            }
        } else {
            // return error message from response body
            response.text().then(text => reject(text));
        }
    });
}

function handleError(error) {    
    return Promise.reject(error && error.message);
}


// WEBPACK FOOTER //
// ./src/_services/user.service.js